import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoText = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	x: "0px",
	y: "0px",
	viewBox: "0 0 3315.0522 928.32227",
	xmlSpace: "preserve",
	width: 3315.0522,
	height: 928.32227,
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "g19",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "FORENSICS_00000064338706709031462540000000034292661671296438_",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "M 756.76532,452.09409 H 649.46753 v 38.707 h -16.29846 v -68.24894 c 0,-14.09375 11.37628,-25.46569 25.46783,-25.46569 h 98.12842 v 16.29632 H 649.46753 v 22.41068 h 107.29779 z",
					id: "path1"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "m 1011.9805,465.33539 c 0,14.08941 -11.3741,25.4657 -25.46573,25.4657 h -72.66266 c -14.09161,0 -25.46789,-11.37629 -25.46789,-25.4657 v -42.78324 c 0,-14.09375 11.37628,-25.46569 25.46789,-25.46569 h 72.66266 c 14.09163,0 25.46573,11.37194 25.46573,25.46569 z m -16.29636,9.16504 v -61.11765 h -91.00146 v 61.11765 z",
					id: "path2"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "m 1267.1957,490.80109 h -16.3007 v -28.52072 h -90.9992 v 28.52072 h -16.2986 v -93.71463 h 98.1306 c 14.0915,0 25.4679,11.37194 25.4679,25.46569 v 14.25818 c 0,7.81064 -4.0763,13.92502 -10.3573,17.31754 6.281,3.39688 10.3573,9.51123 10.3573,17.31753 z m -16.3007,-44.82135 v -32.59696 h -90.9992 v 32.59696 z",
					id: "path3"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "m 1522.4108,490.80109 h -98.1305 c -14.0917,0 -25.4679,-11.37629 -25.4679,-25.4657 v -42.78324 c 0,-14.09375 11.3762,-25.46569 25.4679,-25.46569 h 98.1305 v 16.29632 h -107.3 v 22.41068 h 107.3 v 16.30063 h -107.3 v 22.40634 h 107.3 z",
					id: "path4"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "m 1778.645,397.08646 v 76.90768 c 0,10.18628 -8.1524,18.33444 -18.3387,18.33444 -5.0889,0 -9.6757,-2.03811 -13.0683,-5.43066 l -76.912,-78.09769 v 82.00086 h -16.2984 v -76.90772 c 0,-10.18628 8.1503,-18.33444 18.3365,-18.33444 5.0932,0 9.6801,2.03381 13.0725,5.43066 l 76.9078,78.09769 v -82.00082 z",
					id: "path5"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "m 2033.5183,465.33539 c 0,14.08941 -11.3762,25.4657 -25.47,25.4657 h -98.1284 v -16.30066 h 107.3021 v -22.40634 h -86.2502 c -14.0894,0 -25.4657,-11.37626 -25.4657,-25.47004 v -4.0719 c 0,-14.09375 11.3763,-25.46569 25.4657,-25.46569 h 98.1328 v 16.29632 h -107.2978 v 22.41068 h 86.2415 c 14.0938,0 25.47,11.37625 25.47,25.46566 z",
					id: "path6"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "m 2176.6802,490.80109 h -16.2964 v -93.71463 h 16.2964 z",
					id: "path7"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "m 2431.8735,490.80109 h -98.1281 c -14.0938,0 -25.4659,-11.37629 -25.4659,-25.4657 v -42.78324 c 0,-14.09375 11.3721,-25.46569 25.4659,-25.46569 h 98.1281 v 16.29632 h -107.2976 v 61.11765 h 107.2976 z",
					id: "path8"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "m 2681.9956,465.33539 c 0,14.08941 -11.3718,25.4657 -25.47,25.4657 h -98.124 v -16.30066 h 107.2979 v -22.40634 h -86.2503 c -14.0893,0 -25.4614,-11.37626 -25.4614,-25.47004 v -4.0719 c 0,-14.09375 11.3721,-25.46569 25.4614,-25.46569 h 98.1326 v 16.29632 h -107.2976 v 22.41068 h 86.2414 c 14.0982,0 25.47,11.37625 25.47,25.46566 z",
					id: "path9"
				})
			]
		}), /* @__PURE__ */ _jsxs("g", {
			id: "TRUFFLEPIG_00000123401573256637873190000008255165992041193150_",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "M 341.67307,64.062614 H 202.87001 V 245.57699 H 138.80522 V 64.062614 H 0 V 0 h 341.67307 z",
					id: "path10"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "M 708.22772,245.57698 H 644.1651 V 181.51436 H 427.06091 v 64.06262 H 362.99612 V 0 h 267.82169 c 42.70917,0 77.40991,34.698589 77.40991,77.409897 v 26.694563 c 0,18.68186 -8.89746,34.69859 -22.24475,45.37642 13.34729,10.67783 22.24475,26.69457 22.24475,45.38077 z M 644.1651,117.45175 V 64.062614 H 427.06091 v 53.389136 z",
					id: "path11"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "m 1081.9038,168.16708 c 0,42.70696 -34.7007,77.4099 -77.4098,77.4099 H 814.08215 c -42.70916,0 -77.40991,-34.70294 -77.40991,-77.4099 V 0 H 800.737 v 181.51436 h 217.1042 V 0 h 64.0626 z",
					id: "path12"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "m 1455.58,154.81979 h -281.1669 v 90.75719 h -64.0647 V 77.409897 C 1110.3484,34.698589 1145.0491,0 1187.7583,0 H 1455.58 V 64.062614 H 1174.4131 V 90.757179 H 1455.58 Z",
					id: "path13"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "m 1822.1346,154.81979 h -281.1668 v 90.75719 h -64.0647 V 77.409897 C 1476.9031,34.698589 1511.6038,0 1554.3129,0 h 267.8217 v 64.062614 h -281.1668 v 26.694565 h 281.1668 z",
					id: "path14"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "m 2124.6267,245.57698 h -203.7569 c -42.7114,0 -77.4142,-34.70294 -77.4142,-77.4099 V 0 h 64.0669 v 181.51436 h 217.1042 z",
					id: "path15"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "m 2482.2947,245.57698 h -267.8196 c -42.7112,0 -77.4141,-34.70294 -77.4141,-77.4099 V 77.409897 C 2137.061,34.698589 2171.7639,0 2214.4751,0 h 267.8196 v 64.062614 h -281.1668 v 26.694565 h 281.1668 v 64.062611 h -281.1668 v 26.69457 h 281.1668 z",
					id: "path16"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "m 2855.9709,104.10446 c 0,42.70697 -34.6987,77.4099 -77.4099,77.4099 h -203.757 v 64.06262 h -64.0625 V 0 h 267.8195 c 42.7112,0 77.4099,34.698589 77.4099,77.409897 z m -64.0627,13.34729 V 64.062614 H 2574.804 v 53.389136 z",
					id: "path17"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "m 2941.3586,245.57698 h -64.0669 V 0 h 64.0669 z",
					id: "path18"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "m 3315.0522,168.16708 c 0,42.70696 -34.6987,77.4099 -77.4099,77.4099 h -190.4096 c -42.7115,0 -77.4143,-34.70294 -77.4143,-77.4099 V 77.409897 C 2969.8184,34.698589 3004.5212,0 3047.2327,0 h 267.8195 V 64.062614 H 3033.8855 V 181.51436 h 217.104 v -26.69457 h -108.552 V 90.757179 h 172.6147 z",
					id: "path19"
				})
			]
		})]
	}), /* @__PURE__ */ _jsx("path", {
		d: "m 899.0733,928.32228 q -29.68746,0 -44.65489,-24.24476 -15.09112,-24.36845 -15.09112,-71.4973 0,-47.25254 15.09112,-71.62099 14.96743,-24.24476 44.65489,-24.24476 29.68746,0 44.77859,24.24476 7.42186,11.87498 11.25649,29.68746 3.83463,17.68877 3.83463,41.93353 0,24.24476 -3.83463,41.93354 -3.83463,17.68878 -11.25649,29.56376 -15.21483,24.24476 -44.77859,24.24476 z m 0,-19.79164 q 17.68878,0 26.22393,-18.80206 8.53514,-18.67836 8.53514,-57.14836 0,-38.5937 -8.53514,-57.14836 -8.53515,-18.92575 -26.22393,-18.92575 -17.44138,0 -25.97653,18.80205 -4.32942,9.27734 -6.55598,23.37888 -2.10286,13.97784 -2.10286,33.89318 0,38.7174 8.65884,57.14836 8.65885,18.80206 25.97653,18.80206 z m 0.2474,-32.7799 q -3.95833,0 -6.18489,-5.31901 -2.10286,-5.319 -3.58723,-12.49347 -1.23698,-5.6901 -2.10287,-13.73045 -0.74218,-8.04035 -0.74218,-12.24608 0,-2.96874 0.49479,-10.638 0.49479,-7.66926 1.97916,-14.47264 3.58724,-17.68878 9.64843,-17.68878 3.46353,0 5.81379,4.70052 2.47396,4.70051 4.20572,13.35935 1.23698,6.18489 1.97917,13.85415 0.74219,7.66926 0.74219,11.87499 0,2.47395 -0.4948,9.77212 -0.37109,7.29817 -1.60807,14.96743 -3.09244,18.05987 -10.14321,18.05987 z m 328.4175,49.4791 q -25.4817,0 -36.1197,-10.26692 -10.5143,-10.39061 -10.5143,-35.37755 v -75.70303 h -36.9856 v -17.68877 h 36.9856 v -36.24344 l 22.7604,-9.89582 v 46.13926 h 51.7056 v 17.68877 h -51.7056 v 75.70303 q 0,15.21482 5.8138,21.39971 5.8138,6.06119 20.2864,6.06119 h 25.6054 v 18.18357 z m 242.5713,-139.03627 h 20.6576 l 2.2265,27.0898 q 5.8138,-14.72003 17.4414,-22.51299 11.7513,-7.91665 28.0794,-7.91665 17.0703,0 29.6875,8.65884 v 23.25518 q -13.3594,-10.88541 -31.6667,-10.88541 -21.0286,0 -32.2851,13.48306 -11.2565,13.35936 -11.2565,38.47 v 68.89965 h -22.8841 z m 333.9839,142.12871 q -42.1809,0 -42.1809,-56.03508 v -85.84624 h 22.7604 v 85.84624 q 0,36.24344 27.0898,36.24344 15.8333,0 24.4922,-11.38019 8.6588,-11.50389 8.6588,-32.40881 v -78.30068 h 22.8841 v 138.29409 h -20.6575 l -2.2266,-20.78123 q -12.3698,24.36846 -40.8203,24.36846 z m 311.5947,0 q -19.7916,0 -46.5103,-8.65884 v -23.50257 q 25.9765,13.11196 46.2629,13.11196 14.4727,0 23.1315,-6.06119 8.6589,-6.06119 8.6589,-16.20441 0,-8.78254 -7.2982,-14.10154 -7.1745,-5.4427 -23.0078,-8.78254 l -9.5247,-1.97917 q -19.5443,-3.95832 -28.6979,-12.98826 -9.0299,-9.15363 -9.0299,-24.86325 0,-19.91533 13.6067,-30.67704 13.6068,-10.7617 38.7174,-10.7617 21.276,0 41.1914,8.16405 v 22.26559 q -19.4206,-11.38019 -40.5729,-11.38019 -29.9349,0 -29.9349,20.41013 0,6.67968 2.5977,10.63801 2.5977,3.83463 9.8958,6.55598 7.2982,2.59765 21.5234,5.4427 l 9.1537,1.73177 q 34.3879,6.80337 34.3879,37.48041 0,20.53383 -14.5963,32.40881 -14.5963,11.75129 -39.9544,11.75129 z m 332.0048,-3.09244 q -25.4817,0 -36.1197,-10.26692 -10.5143,-10.39061 -10.5143,-35.37755 v -75.70303 h -36.9856 v -17.68877 h 36.9856 v -36.24344 l 22.7604,-9.89582 v 46.13926 h 51.7056 v 17.68877 h -51.7056 v 75.70303 q 0,15.21482 5.8138,21.39971 5.8138,6.06119 20.2864,6.06119 h 25.6054 v 18.18357 z",
		id: "text19",
		fill: "currentColor",
		"aria-label": "0 t r u s t"
	})]
});
export default SvgLogoText;
